import { SB } from '@play-co/replicant';

export const saveStateSchema = {
  // Save state schema
  saveState: SB.object({
    // Time when the save state was created
    timestamp: SB.int(),
    // Level of the save state
    level: SB.int(),
    // The saved gameplay data
    data: SB.string(),
  }).optional(),
};
